<template>
  <div
    :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'"
    class="h-full flex-1 relative py-10 md:overflow-y-scroll"
  >
    <NavMenu class="z-20" />
    <div
      class="mb-20 px-10"
      v-for="(pageModule, index) in pageModules"
      :key="index"
    >
      <ModuleChart
        v-if="pageModule.type === 'chart'"
        :pageModule="pageModule"
      />
      <ModuleSpotifyPlaylist
        v-if="pageModule.type === 'playlist'"
        :pageModule="pageModule"
      />
      <ModuleCard
        :pageModule="pageModule"
        v-if="pageModule.type === 'advertisement'"
      />
      <ModuleVideo
        :pageModule="pageModule"
        v-if="pageModule.type === 'video'"
      />
      <ModuleNewsletter
        :pageModule="pageModule"
        v-if="pageModule.type === 'newsletter'"
      />
      <ModuleSocialBar
        :pageModule="pageModule"
        v-if="pageModule.type === 'social'"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { PageModule, PageModuleData } from '@/types'
import { Prop, Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({
  components: {
  }
})
export default class Modules extends Vue {
  @Prop() pageModules!: PageModule<PageModuleData>[]

  @Getter themeIsDark!: boolean
  @Getter themePrimaryColor!: string
}
</script>
